// extracted by mini-css-extract-plugin
export default {"video":"SecOne_video__wLPSB"};